import Color from "color";

import { cx, styled } from "simplydo/react/styled";
import { useTheme } from "simplydo/react/theme";

import { resolveUiPalette } from "../utils";
import { UiColorPalette } from "../utils/UIContext";
import type { CardContentProps } from "./Card.types";

const Content = styled.div<{
  $textAlign?: "left" | "center" | "right";
  $color?: UiColorPalette;
}>`
  flex-grow: 1;
  padding: 1em;
  text-align: ${({ $textAlign }) => $textAlign ?? "left"};
  background: ${({ $color }) => ($color ? $color.softer : "transparent")};
`;

const CardContentComponent = (props: CardContentProps) => {
  const { color, textAlign, children, className, style } = props;

  const theme = useTheme();
  const uiColor = color ? resolveUiPalette(theme, color) : undefined;

  return (
    <Content
      className={cx(className)}
      style={style}
      $color={uiColor}
      $textAlign={textAlign}
    >
      {children}
    </Content>
  );
};

export const CardContent = styled(CardContentComponent)``;
